<template>
  <div class="d-inline-flex">
    <v-menu
      ref="menu"
      v-model="menu"
      :close-on-content-click="false"
      :return-value.sync="dateValue"
      transition="scale-transition"
      offset-y
      min-width="290px">
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          v-model="dateValue"
          :disabled="disabled"
          class="date-field"
          readonly
          solo
          v-bind="attrs"
          v-on="on" />
      </template>
      <v-date-picker
        v-model="dateValue"
        no-title
        scrollable>
        <v-spacer />
        <v-btn
          text
          color="primary"
          @click="menu = false">
          ยกเลิก
        </v-btn>
        <v-btn
          text
          color="primary"
          @click="returnValue">
          ยืนยัน
        </v-btn>
      </v-date-picker>
    </v-menu>
    <v-text-field
      v-model="time.hour"
      type="number"
      max="23"
      maxlength="2"
      min="00"
      class="ml-2 hour-field"
      :disabled="disabled"
      @input="watching('hour', $event)" />
    <v-text-field
      v-model="time.minute"
      type="number"
      max="59"
      min="00"
      class="minute-field"
      :disabled="disabled"
      @input="watching('minute', $event)">
      <template v-slot:prepend-inner>
        :
      </template>
    </v-text-field>
  </div>
</template>

<script>
  export default {
    props: {
      disabled: {
        type: Boolean,
        default: false
      },
      label: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        dateValue: new Date().toISOString().substr(0, 10),
        menu: false,
        time: {
          hour: '00',
          minute: '00'
        },
        watchingData: {
          hour: null,
          minute: null
        }
      }
    },
    methods: {
      returnValue () {
        this.$refs.menu.save(this.dateValue)
        this.$emit('input', this.dateValue)
      },
      watching (field, val) {
        clearTimeout(this.watchingData[field])
        this.watchingData[field] = setTimeout(() => {
          this.actionHandle(field, val)
        }, 500)
      },
      actionHandle (field, val) {
        if (val.length >= 2) {
          this.time[field] = val.slice(0, 2)
        } else if (val.length === 1) {
          this.time[field] = `0${val}`
        } else if (!this.time[field]) {
          this.time[field] = '00'
        }

        this.returnValue()
      }
    }
  }
</script>

<style>
.hour-field input {
  text-align: right;
  width: 32px;
}

.minute-field input {
  text-align: left;
  width: 32px;
}

.date-field input {
  width: 85px;
}
</style>
